import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Comentario } from 'src/app/shared/model/tickets/comentario.model';
import { TicketPerfil } from 'src/app/shared/model/tickets/ticketperfil.model';
import { Tickets } from 'src/app/shared/model/tickets/tickets.model';
import { SweetAlertComponent } from 'src/app/shared/SweetMesssage';
import { MensajesFijosEnum } from 'src/app/utilerias/enums/mensajes-fijos-enum';
import { TicketsEstatus } from "src/app/utilerias/enums/tickets-estatus.enum";

import { ProcesoPerfilTicketsComponent } from '../proceso-perfil-tickets/proceso-perfil-tickets.component';
import { ReclutamientoPerfilTicketComponent } from '../reclutamiento-perfil-ticket/reclutamiento-perfil-ticket.component';
import { SolicitudPerfilTicketsComponent } from '../solicitud-perfil-tickets/solicitudPerfilTickets.component';
import { ModalTicketsComponent } from 'src/app/tickets/atencion/detalle-tickets/modal-tickets/modal-tickets.component';
import { TicketsService } from 'src/app/tickets/tickets.service';
import { EvidenciaViewerService } from 'src/app/shared/services/evidencia-viewer.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass, NgIf, NgFor, CurrencyPipe, DatePipe } from '@angular/common';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';

@Component({
    selector: 'app-detalle-perfil-tickets',
    templateUrl: './detalle-perfil-tickets.component.html',
    styleUrls: ['./detalle-perfil-tickets.component.css'],
    imports: [MatIconButton, MatIcon, NgClass, NgIf, MatButton, MatTabGroup, MatTab, MatAccordion, NgFor, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, CurrencyPipe, DatePipe]
})
export class DetallePerfilTicketsComponent {
  ESTATUS: typeof TicketsEstatus= TicketsEstatus;
  ticketBase: Tickets= new Tickets();
  ticketPerfil: TicketPerfil= new TicketPerfil();
  listComentario: [];
  esResolutor:boolean;
  esReclutamiento:boolean;
  cambioDeEstatus: boolean = false;
  @ViewChild('linkDescargaArchivos') private linkDescarga: ElementRef;

  constructor(    
    private ticketService: TicketsService,
    private visorEvidencias: EvidenciaViewerService,
    private alert: SweetAlertComponent,
    public modalDetalle: MatDialogRef<DetallePerfilTicketsComponent>,
    private modal: MatDialog, 
    @Inject(MAT_DIALOG_DATA) public paramIn:any) {}

  ngOnInit(){
    this.ticketBase = this.paramIn.ticket;
    this.esResolutor = this.paramIn.ticket.esResolutor;
    if (this.ticketBase.id_ticket) {
      this.consultarDetallePerfil();
      this.consultarComentarios();

    }
    console.log(this.ticketBase);
   
  }
    
  onCloseClick() {
    this.modalDetalle.close();
  }
  onClickEditar() {
    this.modalDetalle.close();
    this.modal.open(SolicitudPerfilTicketsComponent, {
      disableClose: true,
      autoFocus: true,
      width: '80%',
      panelClass: 'custom-modalbox',

    });
  }
  onClickProcesar() {
    this.cambioDeEstatus = true;
    this.modalDetalle.close();
    this.modal.open(ProcesoPerfilTicketsComponent, {
      disableClose: true,
      autoFocus: true,
      panelClass: 'custom-modalbox',
      data:{
        datos: this.ticketBase,
        cambioEstatus: this.cambioDeEstatus,
        // redireccionamiento: '/Admin',
      }

    });
  }
  
  onClickReclutar() {
    this.modalDetalle.close();
    this.modal.open(ReclutamientoPerfilTicketComponent, {
      disableClose: true,
      autoFocus: true,
      panelClass: 'custom-modalbox',

    });
  }
  onClickComentar() {
    
    this.mostrarModalComentario(false,false,false);
  }

  onClickAtender() {
    this.modalDetalle.close();
    this.mostrarModalComentario(true,false,false);
  }
  onClickCancelar() {
    this.modalDetalle.close();
    this.mostrarModalComentario(true,true,false);
  }

  consultarDetallePerfil(){
      this.ticketService.consultarDetallePerfilTicket(this.ticketBase.id_ticket).subscribe(res => {
        if (res && res.pCodRetorno == '00000') 
          this.ticketPerfil= res;
        else
         this.alert.showSwal('error-message', res? res.pMensaje: MensajesFijosEnum.ERROR_SERVIDOR);

      });
  }

  consultarComentarios(){
      let reqComentario = new Comentario();
      reqComentario.id_ticket =  this.ticketBase.id_ticket;
      this.ticketService.consultarComentario(reqComentario).subscribe(res => {
        if (res) 
          this.listComentario = res.listComentario;
        else
          this.alert.showSwal('error-message',  MensajesFijosEnum.ERROR_SERVIDOR);
       
      });
  }
  mostrarModalComentario(actualizarEstatus,cancelar,reabrir){
    this.modal.open(ModalTicketsComponent, { 
        disableClose: true,
        width: '60%',
        panelClass: 'custom-modalbox',
        data: {
          datos: this.ticketBase,
          cambioEstatus: actualizarEstatus,
          cambioDeEstatusCancelado: cancelar,
          cambioDeEstatusReabierto: reabrir,
          redireccionamiento:'/Cte',
          mostrarHoras: false
        }
      }).afterClosed().subscribe(value => {
        if (value) {
          this.ticketService.nuevoComentario(value);
          this.ticketService.nuevoEstatus(this.ticketBase);
        }
      });
  }

  descargarArchivo(evidencia: any) {
    this.ticketService.descargaArchivo(evidencia).subscribe({
      next: response => this.visorEvidencias.descarga(evidencia.nombre, response),
      error: () => this.visorEvidencias.avisoNoDisponible()
    });
  }



}
